<style lang="scss" scoped>
.card-table {
  margin-bottom: 0;
}
</style>

<template>
  <section>
    <v-table
      url="/api/v1/customerProfile"
      :filter="[
        {
          name: 'AffiliateUser',
          value: id
        }
      ]"
      :attributes="[
        {
          attribute: 'name',
          name: 'Name',
          type: 'ProfileCell'
        },
        {
          attribute: 'created_at',
          name: 'Registrierung',
          type: 'DateTimeCell'
        }
      ]"
    ></v-table>
  </section>
</template>

<script lang="babel">
export default {
  props: ["id"]
};
</script>
